export function hsl(percent: number, start = 0, end = 120) {
  const offset = (end - start) * percent;
  return `hsl(${offset + start}, 100%, 50%)`;
}
